import type Keycloak from 'keycloak-js';

let keycloak: Keycloak | undefined;

export const setKeycloakInstance = async (KeycloakInst: Keycloak) => {
  keycloak = KeycloakInst;
  return true;
};

export const getKeycloakInstance = (): Keycloak | undefined => {
  return keycloak;
};

export default { keycloak };
